const AdditionalDocumentEnum = {
    RequestAdding: 1,
    AcceptedAdding: 2
}

export default AdditionalDocumentEnum